<!--
  @Description: 
  @Author: wang.y 
  @Date: 2025-07-23 
-->
<template>
  <div class="header" id="home-header">
    <div class="header-content">
      <div class="header-left">
        <div class="header-logo" @click="handleChangeRoute('index')">
          <img :src="static_img_url+'pic/vbef-logo.png?v=' + $store.state.imgVersion" v-if="language == 'zh'"/>
          <img :src="static_img_url+'pic/vbef-logo-en.png?v=' + $store.state.imgVersion" v-if="language == 'en'"/>
        </div>
        <div class="header-str">
          <p class="p1">{{'中国·苏州' | dealLanguage('SUZHOU·CHINA')}}</p>
          <p class="p2">{{activityDetail.startTime | time_moment('YYYY.M.D')}}-{{activityDetail.endTime | time_moment('YYYY.M.D')}}</p>
        </div>
      </div>
      <div class="header-navigation">
        <Dropdown @on-visible-change="handleChangeVisible($event, '论坛')" @on-click="handleChangeRoute">
          <div :class="['nav-item', visible['theme'] && 'visible']">
            <span>{{'论坛' | dealLanguage('FORUM')}}</span>
            <i class="iconfont">&#xe669;</i>
          </div>
          <DropdownMenu slot="list">
            <!-- <DropdownItem name="agenda">会议议程</DropdownItem> -->
            <!-- <DropdownItem name="guests">演讲嘉宾</DropdownItem> -->
            <DropdownItem name="signUp">{{'报名参会' | dealLanguage('Register for the conference')}}</DropdownItem>
            <DropdownItem :name="'contentPage' + item.id" v-for="item,index in navPosition1" :key="index">{{item.pageName | dealLanguage(item.enPageTitle)}}</DropdownItem>
            <DropdownItem name="agenda">{{'2025会议日程' | dealLanguage('2025 Conference Agenda')}}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <Dropdown @on-visible-change="handleChangeVisible($event, '展览')" @on-click="handleChangeRoute">
          <div :class="['nav-item', visible['ecological'] && 'visible']">
            <span>{{'展览' | dealLanguage('EXHIBITION')}}</span>
            <i class="iconfont">&#xe669;</i>
          </div>
          <DropdownMenu slot="list">
            <DropdownItem :name="'contentPage' + item.id" v-for="item,index in navPosition2" :key="index">{{item.pageName | dealLanguage(item.enPageTitle)}}</DropdownItem>
            <DropdownItem name="compReg">{{'展位申请' | dealLanguage('Booth Application')}}</DropdownItem>
            <DropdownItem name="exhibitors">{{'展商名录' | dealLanguage('Exhibitor List')}}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <div :class="['nav-item']" @click="handleChangeRoute('toplist')">
          <span>{{'榜单' | dealLanguage('AWARDS')}}</span>
        </div>
        <!-- <div :class="['nav-item']" v-for="item,index in navPosition3" :key="index" @click="handleChangeRoute('contentPage' + item.id)">
          <span>{{item.pageName | dealLanguage(item.enPageTitle)}}</span>
        </div> -->
        <Dropdown @on-visible-change="handleChangeVisible($event, '参会观展')" @on-click="handleChangeRoute">
          <div :class="['nav-item', visible['join'] && 'visible']">
            <span>{{'参会观展' | dealLanguage('VISIT')}}</span>
            <i class="iconfont">&#xe669;</i>
          </div>
          <DropdownMenu slot="list">
            <DropdownItem :name="'contentPage' + item.id" v-for="item,index in navPosition4" :key="index">{{item.pageName | dealLanguage(item.enPageTitle)}}</DropdownItem>
            <DropdownItem name="signUp2">{{'观众报名' | dealLanguage('Audience registration')}}</DropdownItem>
            <DropdownItem name="qa">{{'常见问题' | dealLanguage('Common problem')}}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <div :class="['nav-item']" @click="handleChangeRoute('newsList')">
          <span>{{'新闻资讯' | dealLanguage('NEWS')}}</span>
        </div>
        <div :class="['nav-item']" @click="handleChangeRoute('exhibitors')">
          <span>{{'合作伙伴' | dealLanguage('PARTNERS')}}</span>
        </div>
        <div :class="['nav-item']" v-if="!user_key" @click="handleChangeRoute('login')">
          <span>{{'登录' | dealLanguage('LOG IN')}}</span>
        </div>
        <Dropdown @on-visible-change="handleChangeVisible($event, '用户中心')" @on-click="handleChangeRoute" v-else>
          <div :class="['nav-item', visible['user'] && 'visible']">
            <span>{{'用户中心' | dealLanguage('USER CENTER')}}</span>
          </div>
          <DropdownMenu slot="list">
            <DropdownItem name="userInfo">{{'个人信息' | dealLanguage('Personal center')}}</DropdownItem>
            <DropdownItem name="myTickets">{{'我的门票' | dealLanguage('My Tickets')}}</DropdownItem>
            <DropdownItem name="orderList">{{'订单和发票' | dealLanguage('Orders and Invoices')}}</DropdownItem>
            <DropdownItem name="companions">{{'同行人' | dealLanguage('Companion')}}</DropdownItem>
            <DropdownItem name="quit"><span style="color: #FF0000">{{'退出登录' | dealLanguage('Log out')}}</span></DropdownItem>
          </DropdownMenu>
        </Dropdown>

        <div :class="['lang-item']" @click="handleChangeLanguage">
          <span :class="[language == 'zh' && 'active']">中</span>
          <span>/</span>
          <span :class="[language == 'en' && 'active']">EN</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { Aexitlogin } from '@/service/app'
import filter from 'js/filter'
export default {
  inject: ['globalInsertRecords', 'login', 'reload'],
  components: {},
  created() {},
  mounted() {},
  data() {
    return {
      filter,
      visible: {
        theme: false,
        ecological: false,
        join: false,
        user: false,
      },
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      user_key: (state) => state.user_key,
      contentNav: (state) => state.contentNav,
      activityDetail: (state) => state.activityDetail,
      language: (state) => state.language,
    }),
    /**
     * 获取论坛1
     */
    navPosition1() {
      let arr = this.contentNav.filter((item) => [1].includes(item.id))
      return arr
    },
    /**
     * 获取展览1-4
     */
    navPosition2() {
      let arr = this.contentNav.filter((item) => [2, 3, 5].includes(item.id))
      return arr
    },
    /**
     * 获取活动
     */
    navPosition3() {
      let arr = this.contentNav.filter((item) => [6].includes(item.id))
      return arr
    },
    /**
     * 获取展会参观1-2
     */
    navPosition4() {
      let arr = this.contentNav.filter((item) => [7].includes(item.id))
      return arr
    },
  },
  methods: {
    handleChangeVisible(value, name) {
      this.visible[name] = value
      if (value) {
        this.globalInsertRecords({
          contentId: 0,
          contentType: 81,
          viewType: 2,
          keyword: name,
        })
      }
    },
    /**
     * 处理路由变化
     *
     * @param name 路由名称
     */
    handleChangeRoute(name) {
      // 判断name是否包含contentPage
      if (name.indexOf('contentPage') > -1) {
        let content_id = name.split('contentPage')[1] - 0
        let index = this.contentNav.findIndex((item) => item.id == content_id)
        if (index > -1) {
          this.globalInsertRecords({
            contentId: content_id,
            contentType: 81,
            viewType: 1,
            keyword: this.contentNav[index].pageName,
          })
        }
        this.$router.push({ name: 'exhibitionDesc', params: { id: content_id } })
        return
      }
      let kw = ''
      switch (name) {
        case 'index':
          kw = 'logo'
          break
        case 'guests':
          kw = '演讲嘉宾'
          break
        case 'signUp':
          kw = '报名参会'
          break
        case 'exhibitors':
          kw = '展商名录'
          break
        case 'toplist':
          kw = '榜单'
          break
        case 'signUp2':
          kw = '观众报名'
          break
        case 'qa':
          kw = '常见问题'
          break
        case 'newsList':
          kw = '新闻资讯'
          break
        case 'exhibitors':
          kw = '合作伙伴'
          break
        case 'login':
          kw = '登录'
          break
        case 'userInfo':
          kw = '个人信息'
          break
        case 'myTickets':
          kw = '我的门票'
          break
        case 'orderList':
          kw = '订单和发票'
          break
        case 'companions':
          kw = '同行人'
          break
        case 'quit':
          kw = '退出登录'
          break
        case 'compReg':
          kw = '展位申请'
          break
        case 'agenda':
          kw = '2025会议日程'
          break
      }
      this.globalInsertRecords({
        contentId: 0,
        contentType: 81,
        viewType: 1,
        keyword: kw,
      })
      const loginCb = () => {
        this.$router.push({ name: 'signUp' })
      }
      switch (name) {
        case 'quit':
          this.exitlogin()
          break
        case 'toplist':
          window.open('https://vb100.vbdata.cn/Index/list', '_blank')
          break
        case 'login':
          this.login()
          break
        case 'signUp':
        case 'signUp2':
          if (!this.user_key) {
            this.login(loginCb)
            return
          }
          loginCb()
          break
        default:
          this.$router.push({ name })
      }
    },
    async exitlogin() {
      let res = await Aexitlogin()
      if (res.code == 0) {
        this.$store.commit('updateUserKey', '')
        this.$store.commit('updateUser', '')
        this.$store.commit('setUUserId', '')
        this.$Message.success( this.language == 'zh' ? '退出登录成功！' : 'Log out successfully!')
        this.$router.push({ name: 'index' })
        this.reload()
      } else {
        this.$Message.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
    },
    handleChangeLanguage() {
      let newLanguage = this.language === 'zh' ? 'en' : 'zh'
      // this.$store.commit('setLanguage', newLanguage)
      // localStorage.setItem('vbefLanguage', newLanguage)

      let routerQuery = this.$route.query
      if (newLanguage == 'en') {
        routerQuery.language = newLanguage
      } else {
        delete routerQuery.language
      }
    
      const { href } = this.$router.resolve({ path: this.$route.path, query: routerQuery })
      location.href = href
      
      // this.$router.resolve({ path: this.$route.path, query: routerQuery })
      // this.$nextTick(() => {
      //   this.reload()
      // })
    },
  },
}
</script>
<style lang='stylus' scoped>
.header-content
  width 1200px
  height 64px
  margin 0 auto
  display flex
  align-items center
  justify-content space-between
  .header-left
    display flex
    align-items center
  .header-logo
    font-size 0
    display flex
    align-items center
    img
      width auto
      height 36px
      cursor pointer
  .header-str
    margin-left 6px
    height 36px
    .p1
      font-size 16px
      color #FA5A00
      line-height 18px
    .p2
      color #FA5A00
      font-size 12px
      line-height 1
      margin-top 5px
  .header-navigation
    display flex
    align-items center
    justify-content space-between
    font-size 14px
    > div
      &+div
        margin-left 40px
    .lang-item
      width 41px
      color #333333
      cursor pointer
      display flex
      align-items center
      justify-content center
      position relative
      transition all 0.3s
      span
        transition all 0.2s
        font-size 14px
        &.active
          font-size 16px
          color #FA5A00
      &:hover
        color #FA5A00
    .nav-item
      color #333333
      cursor pointer
      display flex
      align-items center
      justify-content center
      transition all 0.3s
      font-size 16px
      position relative
      span
        &+i
          transition all 0.3s
          margin-left 4px
        &.active
          color #FA5A00
      &:hover, &.active
        color #FA5A00
      &.visible
        color #FA5A00
        i
          transform rotate(180deg)
  >>> .ivu-dropdown
    .ivu-select-dropdown
      padding 20px 0 5px
      margin 0
      border-radius 0
      box-shadow none
      background none
      .ivu-dropdown-menu
        box-shadow 0 1px 6px rgba(0, 0, 0, 0.2)
        background-color #fff
        padding 5px 0
        .ivu-dropdown-item
          color #333333
</style>